<div class="pass-content-wp" [formGroup]="passForm">
  <div class="label-wp">
    <div class="label">Please enter password</div>
    <div class="sub-label">This data is HIPAA Compliant</div>
  </div>
  <div class="input-wp">
    <div class="label">Password</div>
    <rx-input [type]="'password'" formControlName="password" placeholder="Enter password"></rx-input>
  </div>

  <div class="error-wp">
    <span *ngIf="errorMessage"> {{ errorMessage }} </span>
  </div>
</div>
<rx-row>
  <button class="cancel-btn" (click)="cancelDialog()">Cancel</button>
  <button class="blue-btn" (click)="submitData()" [disabled]="passForm.invalid">
    <span *ngIf="!passChecking">Enter</span>
    <rx-icon *ngIf="passChecking" [name]="'icon-spinner'"></rx-icon>
  </button>
</rx-row>
